import { render, staticRenderFns } from "./JobAllocation.vue?vue&type=template&id=01b3fb07&scoped=true"
import script from "./JobAllocation.vue?vue&type=script&lang=js"
export * from "./JobAllocation.vue?vue&type=script&lang=js"
import style0 from "./JobAllocation.vue?vue&type=style&index=0&id=01b3fb07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3fb07",
  null
  
)

export default component.exports